import { styled } from 'styled-components';

import commonEssence from '#src/assets/rewards/common-essence.webp';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { LabelM } from '#src/atoms/typography/index.tsx';

const CommonEssenceIcon = styled.img.attrs({ src: commonEssence, alt: '' })`
  height: 1.1em;
`;

type Props = {
  price?: Nullable<number>;
};

export const CommonCardPrice = ({ price }: Props) => {
  return (
    <LabelM bold>
      <Horizontal>
        <CommonEssenceIcon />
        {price || 'N/A'}
      </Horizontal>
    </LabelM>
  );
};
